import { getAuthToken, clearSsoSession } from "./auth";
import { API_BASE_URL } from "./config";

export function apiFetch(path: string, init?: RequestInit): Promise<Response> {
  const token = getAuthToken();
  const headers = new Headers(init?.headers);
  if (token) headers.set("Authorization", `Bearer ${token}`);
  if (!headers.has("Content-Type") && init?.body) headers.set("Content-Type", "application/json");

  return fetch(`${API_BASE_URL}${path}`, { ...init, headers }).then((res) => {
    if (res.status === 401) {
      clearSsoSession();
      window.location.reload();
    }
    return res;
  });
}
